import { tablet, lap } from '@braindate/ui/lib/token/mediaQuery';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    width: ({ wrapToContent }) => (wrapToContent ? 'min-content' : '100%'),
    height: ({ wrapToContent }) => (wrapToContent ? 'unset' : '100%'),

    '& a > span': {
      whiteSpace: 'nowrap',
    },
  },
  list: {
    display: 'flex',
    width: ({ wrapToContent }) => (wrapToContent ? 'min-content' : '100%'),
    justifyContent: ({ wrapToContent }) =>
      wrapToContent ? 'flex-start' : 'space-around',
    height: '100%',
    margin: 0,
    padding: 0,

    [tablet]: {
      columnGap: 16,
    },
    [lap]: {
      columnGap: 20,
    },
  },
  badge: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  badgeMenuOpened: {
    border: ({ theme }: ThemeFunction) => `1px solid ${theme.colorBase}`,
  },
  hidden: {
    display: 'none',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '25%',
    position: 'relative',
    justifyContent: 'center',
  },

  itemHome: {
    '& svg': {
      width: 18,
      height: 20,
    },
  },

  itemBraindates: {
    '& svg': {
      width: 26,
      height: 23,
    },
  },

  itemNotifications: {
    '& svg': {
      width: 19,
      height: 19,
    },
  },
  submenuItem: {
    maxHeight: ({ wrapToContent }) => (wrapToContent ? 'unset' : 94),
    marginBottom: 6,
    '&:last-child': {
      marginBottom: 'unset',
    },
  },
  itemMobileOnly: {
    [lap]: {
      display: 'none',
    },
  },
  itemDesktopOnly: {
    display: 'none',
    [lap]: {
      display: 'flex',
    },
  },
};
